export default class Types {
  static ADD_VEHICLE_COMPARATOR    = 'ADD_VEHICLE_COMPARATOR';
  static UPDATE_VEHICLE_COMPARATOR = 'UPDATE_VEHICLE_COMPARATOR';
  static SET_COMPARATOR_STATE      = 'SET_COMPARATOR_STATE';
  static REMOVE_VEHICLE_COMPARATOR = 'REMOVE_VEHICLE_COMPARATOR';
}
